import { makeStyles } from '@material-ui/core';
import { hSpacing, vSpacing } from 'src/common/helpers/config';

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  container: {
    minWidth: '1024px',
  },
  topAreaContainer: {
    padding: `${vSpacing} ${hSpacing} 0 ${hSpacing}`,
    backgroundImage: 'none',
    position: 'relative',
  },
  topAreaContainerTraining: {
    backgroundImage: `linear-gradient(${theme.trainingColor}, ${theme.white})`,
    backgroundRepeat: 'no-repeat',
  },
  mainContainer: {
    flex: '1 1 auto',
    padding: `${vSpacing} ${hSpacing}`,
  },
  sidebarContainer: {
    height: '100%',
    maxWidth: '11.27%',
    padding: `${vSpacing} ${hSpacing}`,
    paddingRight: 0,
  },
  middleAreaContainer: {
    padding: '0',
    flex: '1 1 auto',
  },
  bottomBarContainer: {
    paddingTop: vSpacing,
  },
  ntep: {
    position: 'absolute',
    right: '0',
    bottom: '70%',
    transform: 'rotate(-90deg)',
    transformOrigin: '100% 100%',
    fontSize: '1.22vh',
    fontWeight: 500,
    letterSpacing: '.0625rem',
    color: theme.ntepText,
  },
}));
